import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';

import LoadingCenter from '../../../Components/LoadingCenter';

import AppConfig from '../../../AppConfig';

export default class JointourWholesales extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			jointourWholesales: [],
		};
	}

	async componentDidMount() {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			const request = await APIGet('jointour/wholesales');
			if (APIHelper.handleAPIResponse(this, request)) {
				const jointourWholesales = request.data;
				console.log('jointourWholesales: ', jointourWholesales);
				this.setState({
					isLoading: false,
					jointourWholesales,
				});
			} else {
				toast.error('ไม่สามารถดึงข้อมูลได้');
			}
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	}

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		return (
			<div className="container">
				<div className="columns">
					<div className="column is-6">
						<h1 className="title is-2">Whole Sale</h1>
					</div>
					<div className="column is-6" style={{ textAlign: 'right' }}>
						<Link className="button is-info" to={AppConfig.appPath + '/data/newjointourWholesale'}>
							เพิ่ม
						</Link>
					</div>
				</div>
				<div className="section table-container">
					<table className="table is-hoverable is-fullwidth">
						<thead>
							<tr>
								<td width="80%">ชื่อ</td>
								<td width="20%" style={{ textAlign: 'center' }}>
									ผู้ติดต่อ
								</td>
							</tr>
						</thead>
						<tbody>
							{this.state.jointourWholesales.map(jointourWholesale => (
								<tr key={jointourWholesale.id}>
									<td>
										<Link to={AppConfig.appPath + '/data/jointour/wholesales/' + jointourWholesale.id}>
											{jointourWholesale.name}
											<span> </span>
											{jointourWholesale.shortname ? <span>({jointourWholesale.shortname})</span> : null}
										</Link>
									</td>
									<td style={{ textAlign: 'center' }}>
										<Link to={AppConfig.appPath + '/data/jointour/wholesales/' + jointourWholesale.id + '/contacts'}>ผู้ติดต่อ</Link>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}
